var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWarn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.79646 17.0791C2.26806 17.0791 1.30449 15.4342 2.05191 14.1011L7.6966 4.03264C8.46052 2.67003 10.4218 2.67003 11.1857 4.03263L16.8304 14.1011C17.5778 15.4342 16.6142 17.0791 15.0858 17.0791H3.79646Z",
    stroke: "#F86363",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95911 7.10313L9.03195 12.098C9.03535 12.3311 9.23002 12.5157 9.463 12.5067C9.68289 12.4983 9.85797 12.3197 9.86211 12.0997L9.95615 7.10524C9.9614 6.82625 9.73669 6.59727 9.45765 6.59727C9.17944 6.59727 8.95506 6.82495 8.95911 7.10313ZM9.44659 13.6186C9.11125 13.6186 8.81016 13.884 8.81016 14.2312C8.81016 14.5754 9.10819 14.8557 9.44659 14.8557C9.78792 14.8557 10.0711 14.5725 10.0711 14.2312C10.0711 13.8869 9.7849 13.6186 9.44659 13.6186Z",
    fill: "#F86363",
    stroke: "#F86363",
    strokeWidth: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarn);
export default __webpack_public_path__ + "static/media/icon-warn.c09b57cde5ee4f0457010fc0e57c1e89.svg";
export { ForwardRef as ReactComponent };